import type { SVGProps } from 'react';
const SvgLabelOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#label_off_svg__a)">
      <path
        fill="currentColor"
        d="m3.25 2.75 17 17L19 21l-2-2H5c-1.1 0-2-.9-2-2V7c0-.55.23-1.05.59-1.41L2 4l1.25-1.25ZM22 12l-4.37-6.16C17.27 5.33 16.67 5 16 5H8l11 11 3-4Z"
      />
    </g>
    <defs>
      <clipPath id="label_off_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLabelOff;
